import { render, staticRenderFns } from "./Agb.vue?vue&type=template&id=b69fbbca"
import script from "./Agb.vue?vue&type=script&setup=true&lang=ts"
export * from "./Agb.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports